import { TypeMarkInfo } from '../../module/types/fitsTheAutoSchema';

export enum typeMarks {
  Tires = 'tires',
  Disks = 'disks',
}
export interface TypeAccordionMarks {
  title?: string;
  models: TypeMarkInfo[];
  active: boolean;
  type: typeMarks;
  className?: string;
}
